import React from "react";
import ReviewsInline from "./ReviewsInline";

export type ReviewsScoreSummaryProps = {
  averageScore: number;
  productGroup: string;
};

const ReviewsScoreSummary = ({
  averageScore,
  productGroup,
}: ReviewsScoreSummaryProps) => {
  return (
    <div className="flex items-baseline justify-start space-x-micro">
      <h3 className="font-display text-[32px]">{averageScore?.toFixed(1)}</h3>
      <ReviewsInline productGroup={productGroup} className="hide-count" />
    </div>
  );
};

export default ReviewsScoreSummary;
